import { render, staticRenderFns } from "./ButtonERC721.vue?vue&type=template&id=4b188b10"
import script from "./ButtonERC721.vue?vue&type=script&lang=js"
export * from "./ButtonERC721.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports